export const init = async function() {
    document.querySelectorAll('.gtm-pdp-tooltip').forEach(function(el) {
        el.addEventListener('mouseenter', function() {
            // desktop
            if (window.innerWidth > 1023) {
                Shopify.analytics.publish('pdp_tooltip_hover', {
                    event: 'Hover tooltip desktop'
                });
            }
        });
    });
};
